import _extends from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import React from "react";
import { Box, Flex, Span } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BenefitBox = function BenefitBox(_ref) {
  var containerProps = _ref.containerProps,
      icon = _ref.icon,
      children = _ref.children;
  return ___EmotionJSX(Box, _extends({
    flex: "1 1 auto",
    width: "50%",
    p: "5px"
  }, containerProps), ___EmotionJSX(Flex, {
    height: "160px",
    borderRadius: "default",
    borderColor: "ui.borderColor",
    borderStyle: "solid",
    borderWidth: "1px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    pt: "35px",
    px: "10px"
  }, ___EmotionJSX(Box, {
    color: "brand.clubCatch"
  }, icon), ___EmotionJSX(Box, {
    height: "45%"
  }, ___EmotionJSX(Span, {
    fontSize: "base",
    color: "#222222",
    display: "block",
    textAlign: "center"
  }, children))));
};
export default BenefitBox;